import {getRoutes} from "helpers/getRoutes";
import {Routes} from 'react-router-dom';
import AppLayout from 'layout/AppLayout';
import {NavigationProvider} from 'context/NavigationContext';
import AgentAccordion from 'components/Accordion/AgentAccordion';
import useShowNavbar from 'helpers/BottomNavigation';
import {appRoutes} from "helpers/applicationRoutes/appRoutes";


function Main() {
    const showNavbar = useShowNavbar();
    return (
        <NavigationProvider>
            {showNavbar && <AgentAccordion/>}
            <AppLayout>
                <Routes>
                    {getRoutes(appRoutes)}
                </Routes>
            </AppLayout>

        </NavigationProvider>

    );
}

export default Main;
